export enum CsvTypes {
  APPLICATION_CSV = 'application/csv',
  APPLICATION_EXCEL = 'application/excel',
  APPLICATION_MSEXCEL = 'application/vnd.msexcel',
  APPLICATION_VND_MS_EXCEL = 'application/vnd.ms-excel',
  TEXT_ANYTEXT = 'text/anytext',
  TEXT_COMMA_SEP_VALS = 'text/comma-separated-values',
  TEXT_CSV = 'text/csv',
}
